export const CREATE_ACCOUNT_LINK =
  'https://developers.stellar.org/docs/tutorials/create-account'
export const FREIGHTER_URL = 'https://www.freighter.app/'
export const FREIGHTER_EXTENSION_CHROME_BRAVE =
  'https://chromewebstore.google.com/detail/freighter/bcacfldlkkdogcmkkibnjlakofdplcbk?hl=en'
export const FREIGHTER_EXTENSION_FIREFOX =
  'https://addons.mozilla.org/en-US/firefox/addon/freighter/'
